import { Component, OnInit, AfterViewChecked, ChangeDetectionStrategy } from "@angular/core";
import { ChangeDetectorRef } from "@angular/core";

import { EmbryoService } from "../../../Services/Embryo.service";
import { TranslationService } from "src/app/Services/Translation/Translation.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-homeone",
  templateUrl: "./HomeOne.component.html",
  styleUrls: ["./HomeOne.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeoneComponent implements OnInit, AfterViewChecked {
  productReviews: any;
  productsArray: any;
  singleProduct: any;

  categoryNames: any[] = [];
  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  constructor(
    public embryoService: EmbryoService,
    private cdRef: ChangeDetectorRef,
    public trans:TranslationService,
    public translate : TranslateService
  ) {
    this.embryoService.featuredProductsSelectedTab = 0;
    this.embryoService.newArrivalSelectedTab = 0;
  }

  ngOnInit() {
    this.fetchSingleProduct();
    //this.fetchFeaturedProducts();
    //this.fetchNewProducts();
    this.getProductRevies();
    

  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }
  
  public fetchSingleProduct(): void {
    if (this.embryoService.featuredProducts.length == 0) {
      this.embryoService.db
        .object("/product_lists/single")
        .valueChanges()
        .take(1)
        .subscribe(res1 => {
          this.embryoService.db
            .object("/products/" + res1[0]["category"] + "/" + res1[0]["id"])
            .valueChanges()
            .take(1)
            .subscribe(res2 => {
              this.singleProduct = res2;
            });
        });
    }
  }

  


  public addToCart(value) {
    this.embryoService.addToCart(value);
  }

  public getProductRevies() {
    this.embryoService
      .getProductReviews()
      .valueChanges()
      .subscribe(res => {
        this.productReviews = res;
      });
  }

 
}
